/*我的
i:get || post
h:requestGet ||requestPost
*/
import axios from '../axios'
export default {
    CompanyDataApi: () => {//心语数据
        return axios.get('/api/api/mechanism/company');
    },
    mechanismApi: () => {// 会员中心数据
        return axios.get('/api/api/center/new-tab/wap')
    },
    toggleWalletPageAIP: () => {//账户跳转钱包页面
        return axios.get('/api/api/center/amount');
    },
    getAgentDataAIP: (data) => {//代理签约基本信息
        return axios.get('/passport/agent/info',data);
    },
    getBatchAIP: () => {//获取分批付款数据接口
        return axios.get('/api/api/payment/batch/unfinish');
    },
    getCompanyInfoAIP: () => {//获取运营主体-公司信息
        return axios.get('/api/api/mechanism/company');
    },
    applyAnchorAIP: (mechanismId) => {//申请开通直播间
        return axios.get(`/api/api/live/anchor/apply/${mechanismId}`);
    },
    liveAIP: (mechanismId) => { //
        return axios.post(`/api/api/live/anchor/check/${mechanismId}`);
    },
    bindMobileAIP: (data) => { //绑定手机号弹窗
        return axios.get(`/api/api/mechanism_user/by_openid`,data);
    },
    getContactPhoneAIP: (mechanismId) => { //获取绑定时用的联系电话
        return axios.requestGet(`/v1/shops/${mechanismId}`);
    },
    getGroupAIP: () => { //绑定手机号弹窗
        return axios.get(`/api/api/member/mechanism`);
    },
    toWalletAIP: (data) => { //钱包分机构 确定转入
        return axios.post(`/auth/amount/to-mechanism`,data);
    },
    setUsersAIP: () => { //设置页面获取数据接口
        return axios.requestGet(`/v1/ucentor/users`);
    },
    removeWxBindAIP: () => { //解除当前微信绑定
        return axios.post(`/passport/user/remove-wxBind`);
    },
    wxBindAIP: (data) => { //当前微信绑定
        return axios.post(`/passport/user/wxBind`,data);
    },
    
    // 获取观看历史 
    getViewHistoryApi: (data) => axios.requestGet('/v2/ucentor/histories', data),
    // 批量删除观看历史 
    deleteViewHistoryApi: (data) => axios.requestPost('/v2/ucentor/histories/batch-delete', data),
    mechanismOpenid: (data) => axios.post('/passport/user/mechanism_openid', data),//机构静默授权
}